module.exports = __webpack_public_path__ + "img/dingdan.7c5155f4.svg";